/**
 * Normaliza o slug (campo "Url") da company.
 *
 * Regras: minusculo, sem acento, sem espaco e apenas com caracteres
 * validos em URL ([a-z0-9-]). Espacos e separadores viram hifen.
 */
export const normalizeSlug = (value) => {
  if (value === null || value === undefined) return "";

  return String(value)
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "") // remove acentos (inclusive o cedilha)
    .toLowerCase()
    .replace(/[\s_]+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-{2,}/g, "-");
};
